export default __webpack_public_path__ + "assets/img/MaterialIcons-Regular.cff684e59ffb052d72cb8d5e49471553.woff2";